import actionProducts from '@/data/action/products.json'
import eloProducts from '@/data/elo/products.json'
import mullerProducts from '@/data/muller/products.json'
import mrowkaProducts from '@/data/mrowka/products.json'
import automotivePartsProducts from '@/data/automotive-parts/products.json'
import bruendlProducts from '@/data/bruendl/products.json'
import harleyProducts from '@/data/harley/products.json'

import { baseTheme } from './base'

export const themes = {
  action: {
    ...baseTheme,
    language: "en",
    currency: '€',
    colors: {
      ...baseTheme.colors,
      global: '#001489',
      primary: '#EB7514'
    },
    font: 'Ubuntu',
    title: 'Action - Self Checkout',
    assets: {
      logo: require('@/assets/img/logo_action.svg').default,
      home: `${process.env.PUBLIC_URL}/img/action/home.png`
    },
    products: actionProducts || []
  },
  muller: {
    ...baseTheme,
    language: "en",
    currency: '€',
    colors: {
      ...baseTheme.colors,
      global: '#666666',
      primary: '#ea5b0c'
    },
    font: 'Fira Sans Condensed',
    title: 'Muller - Self Checkout',
    assets: {
      logo: require('@/assets/img/logo_muller.svg').default,
      icons: {
        lock: 'lock_muller'
      },
      lock: require('@/assets/icons/lock_muller.svg').default,
      home: `${process.env.PUBLIC_URL}/img/muller/home.png`
    },
    products: mullerProducts || []
  },
  elo: {
    ...baseTheme,
    language: "en",
    currency: '€',
    colors: {
      ...baseTheme.colors,
      global: '#3A3A3A',
      primary: '#3BA6EF'
    },
    font: 'Nunito Sans',
    title: 'ELO - Self Checkout',
    assets: {
      logo: require('@/assets/img/logo_elo.svg').default,
      lock: require('@/assets/icons/lock_elo.svg').default,
      home: `${process.env.PUBLIC_URL}/img/elo/home.png`
    },
    products: eloProducts || []
  },
  mrowka: {
    ...baseTheme,
    language: "pl",
    currency: 'zł',
    colors: {
      ...baseTheme.colors,
      global: '#0c3b6e',
      primary: '#ffbf00'
    },
    font: 'Ubuntu',
    title: 'Mrówka - Self Checkout',
    assets: {
      logoJpg: require('@/assets/img/logo_mrowka.jpg'),
      home: `${process.env.PUBLIC_URL}/img/mrowka/home.png`
    },
    products: mrowkaProducts || []
  },
  automotive_parts: {
    ...baseTheme,
    language: "pl",
    currency: 'zł',
    colors: {
      ...baseTheme.colors,
      global: '#2c3e50',
      primary: '#e74c3c'
    },
    font: 'Ubuntu',
    title: 'Berg Automotive Parts - Self Checkout',
    assets: {
      logo: require('@/assets/img/logo_automotive_parts.svg').default,
      home: `${process.env.PUBLIC_URL}/img/automotive-parts/home.png`
    },
    additionalInfo: {
      text: 'Dowiedz się więcej na',
      links: ['bergauto.pl', 'bergpos.com']
    },
    products: automotivePartsProducts || []
  },
  bruendl: {
    ...baseTheme,
    language: "de",
    currency: '€',
    colors: {
      ...baseTheme.colors,
      global: '#0e3a5a',
      primary: '#e40321'
    },
    font: 'Ubuntu',
    title: 'Bründl - Self Checkout',
    assets: {
      logoJpg: require('@/assets/img/logo_bruendl.webp'),
      home: `${process.env.PUBLIC_URL}/img/bruendl/home.png`
    },
    products: bruendlProducts || []
  },
  harley: {
    ...baseTheme,
    language: "pl",
    currency: 'zł',
    colors: {
      ...baseTheme.colors,
      global: '#1A1A1A',
      primary: '#FF6600',
      secondary: '#FF8833',
      tertiary: '#CC5200',
      text: '#FFFFFF',
      textLight: '#FFE0CC',
      textAccent: '#FF9966',
      background: '#0D0D0D',
      backgroundLight: '#262626',
      cardBackground: '#1A1A1A',
      border: '#FF6600',
      shadow: '#000000',
      grayMedium: '#666666',
      grayLight: '#CCCCCC'
    },
    font: 'Arial Black, sans-serif',
    title: 'Harley-Davidson Katowice - Self Checkout',
    assets: {
      logo: require('@/assets/img/logo_harley.svg').default,
      home: `${process.env.PUBLIC_URL}/img/harley/home.png`
    },
    products: harleyProducts || []
  },
}
